import { DataViewContainer, EntryListContainer, SearchContainer } from '@/components/molecule';
import styles from './splitPane.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SplitPane() {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.outerContainer,
    children: [/*#__PURE__*/_jsx(SearchContainer, {}), /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.leftPane,
        children: /*#__PURE__*/_jsx(EntryListContainer, {})
      }), /*#__PURE__*/_jsx("div", {
        className: styles.rightPane,
        children: /*#__PURE__*/_jsx(DataViewContainer, {})
      })]
    })]
  });
}